export const updateSets = (sets) => {
    return {
        type: "RELOAD",
        data: sets
    }
}

export const setSyncStatus = (data) => {
    return {
        type: "SET_SYNC_STATUS",
        data: data
    }
}

export const updateSetsOnly = (data) => {
    return {
        type: "UPDATE_SETS_ONLY",
        data: data
    }
}